export const GSTA_TABLE_IDS = { STUDENT_TABLE: "student_table", TRAINING_TABLE: "training_table" };
